import { render, staticRenderFns } from "./WhatsappGroupsPanel.vue?vue&type=template&id=998062a8&scoped=true"
import script from "./WhatsappGroupsPanel.vue?vue&type=script&lang=js"
export * from "./WhatsappGroupsPanel.vue?vue&type=script&lang=js"
import style0 from "./WhatsappGroupsPanel.vue?vue&type=style&index=0&id=998062a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "998062a8",
  null
  
)

export default component.exports